import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  CheckInEventListItem,
  CheckInEventStats,
  ScanTicketRequest,
  ScanTicketResponse,
} from "@ticketnjoy/types";

import { apiClient, type ApiError } from "@/lib/api-client";

export const checkInEventsQueryKey = ["check-in", "events"] as const;
export const checkInStatsQueryKey = (eventId: string) =>
  ["check-in", "stats", eventId] as const;

export function useCheckInEventsQuery() {
  return useQuery<CheckInEventListItem[], ApiError>({
    queryKey: checkInEventsQueryKey,
    queryFn: () => apiClient<CheckInEventListItem[]>("/check-in/events"),
    staleTime: 30 * 1000,
  });
}

export function useCheckInEventStatsQuery(eventId: string | null, enabled = true) {
  return useQuery<CheckInEventStats, ApiError>({
    queryKey: eventId ? checkInStatsQueryKey(eventId) : ["check-in", "stats", "noop"],
    queryFn: () => apiClient<CheckInEventStats>(`/check-in/events/${eventId}/stats`),
    enabled: !!eventId && enabled,
    staleTime: 5 * 1000,
  });
}

export function useScanTicketMutation() {
  return useMutation<ScanTicketResponse, ApiError, ScanTicketRequest>({
    mutationFn: (body) =>
      apiClient<ScanTicketResponse>("/check-in/scan", {
        method: "POST",
        body,
      }),
  });
}
